import styles from "./NewsCategoryResults.module.css";
import BasicPage from "../../components/BasicPage/BasicPage";
import PagedSection from "../../components/PagedSection/PagedSection";
import { useContext, useEffect, useMemo, useState } from "react";
import { PostContext } from "../../components/PostProvider/PostProvider";
import ArrowSubtitle from "../../components/ArrowSubtitle/ArrowSubtitle";
import usePageTitle from "../../hooks/usePageTitle";
import NewsSearchBar from "../../components/NewsSearchBar/NewsSearchBar";
import HorizontalPostLink from "../../components/HorizontalPostLink/HorizontalPostLink";
import { useParams } from "react-router-dom";
import SearchCover from "../../components/SearchCover/SearchCover";
import { toTitleCase } from "../../data/utils";

function NewsCategoryResults() {
    const { getPostsWithQuery } = useContext(PostContext);
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [searchBarState, setSearchBarState] = useState(false);
    const [loading, setLoading] = useState(false);
    const [totalQueryResults, setTotalQueryResults] = useState(0);

    const { slug } = useParams();
    const categoryName = useMemo(
        () => toTitleCase(slug.replace(/-/g, " ")),
        [slug]
    ); // could get from suggestions array...

    const [searchResults, setSearchResults] = useState({});

    useEffect(() => {
        const load = async () => {
            const results = await getPostsWithQuery(
                currentPage,
                perPage,
                slug,
                "",
                setLoading,
                setTotalQueryResults
            );
            setSearchResults(results);
        };
        load();
    }, [currentPage, getPostsWithQuery, perPage, slug]);

    useEffect(() => {
        console.log(searchResults, totalQueryResults);
    }, [searchResults, totalQueryResults]);

    usePageTitle(`${categoryName} | News`);

    return (
        <BasicPage>
            <SearchCover
                searchBarState={searchBarState}
                setSearchBarState={setSearchBarState}
            />
            <div id={styles.heading}>
                <ArrowSubtitle dark={true} text={"News"} />
                <h1 className="main-h1">
                    {categoryName}
                    <br />
                </h1>
            </div>
            <NewsSearchBar
                searchBarState={searchBarState}
                setSearchBarState={setSearchBarState}
            />
            <div id={styles.latest_container}>
                <PagedSection
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    perPage={perPage}
                    setPerPage={setPerPage}
                    total={totalQueryResults}
                    className={[styles.links_container, "section-content"].join(
                        " "
                    )}
                >
                    {loading ? (
                        Array(perPage)
                            .fill(0)
                            .map((_, index) => (
                                <HorizontalPostLink
                                    key={index}
                                    placeholder={true}
                                />
                            ))
                    ) : totalQueryResults > 0 ? (
                        searchResults?.posts.map((post) => (
                            <HorizontalPostLink key={post.id} post={post} />
                        ))
                    ) : (
                        <div id={styles.no_results_container}>
                            <img
                                src="/images/no-search-results-icon.png"
                                alt="No posts found"
                                draggable={false}
                            />
                            <div className={styles.message}>
                                <div>
                                    No posts found in{" "}
                                    <span
                                        style={{ color: "var(--keel-orange)" }}
                                    >
                                        {categoryName}
                                    </span>
                                </div>
                            </div>
                        </div>
                    )}
                </PagedSection>
            </div>
        </BasicPage>
    );
}

export default NewsCategoryResults;
